// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Tu1v","right":"Footer_right__2J8P7","buttons":"Footer_buttons__3DVAp"};